import { AppEntities } from "../../../../config/entities";
import { IListViewField } from "../../../Shared/ILIstViewField";
import { ProductHelper } from "../../../../helpers/ProductHelper";
import { NewCatalogListView } from "../../../Shared/NewCatalogListView";
import { Button } from "react-bootstrap";
import { CatalogListViewToolbar } from "../../../Shared/ListViews/CatalogListViewToolbar";
import { CatalogListView } from "../../../Shared/CatalogListView";
import { CatalogListViewDefaultToolbarButtons } from "../../../Shared/ListViews/CatalogListViewDefaultToolbarButtons";

const ProductList = () => {
  const fields: IListViewField[] = [
    { title: "Name", fieldName: "name" },
    { title: "Vendor code", fieldName: "vendorCode" },
    { title: "Barcode", fieldName: "barCode" },
    {
      title: "Item Type",
      fieldName: "itemType",
      cellRender: (column: any) => ProductHelper.GetItemTypeName(column.data.itemType)
    }
  ];

  return (
    <>
      <CatalogListView fields={fields} entity={AppEntities.Product}>
        <CatalogListViewToolbar>
          <CatalogListViewDefaultToolbarButtons />
        </CatalogListViewToolbar>
      </CatalogListView>{" "}
    </>
  );
};

export default ProductList;
